import { Component, Input } from '@builder.io/sdk';

import imageField from 'molecules/Image/config';
import sectionFields, { SectionConfigProps } from 'molecules/Section/config';

import { rtcCardColorField } from 'organisms/Cards/config';

const resourceDownloadCardFields = [
  {
    name: 'heading',
    type: 'string',
    defaultValue:
      'Lorem ipsum dolor sit amet consectetur. Donec sed ac ut neque mattis. Imperdiet volutpat quam egestas sem. ',
    helperText: 'Main title of the card. Keep it concise and engaging.',
  },
  {
    name: 'description',
    type: 'richText',
    defaultValue:
      '<p>Lorem ipsum dolor sit amet consectetur. Donec sed ac ut neque mattis. Imperdiet volutpat quam egestas sem et consequat phasellus in quis.</p>',
    helperText: 'Supporting text shown below the heading. Can include formatting and links.',
  },
  imageField('image'),
  {
    name: 'useForm',
    type: 'boolean',
    defaultValue: false,
    helperText: 'Gate the download behind a single-field Marketo form instead of a direct button.',
  },
  {
    name: 'buttonLabel',
    type: 'string',
    defaultValue: 'Get my copy',
    helperText: 'Text that appears on the button.',
    showIf: "options.get('useForm') === false",
  },
  {
    name: 'resource',
    type: 'string',
    defaultValue: 'https://example.com',
    helperText: 'URL to the resource file or landing page. Use full absolute links.',
    showIf: "options.get('useForm') === false",
  },
  {
    name: 'form',
    type: 'reference',
    model: 'marketo-forms',
    showIf: "options.get('useForm') === true",
    helperText: 'Select the single-field Marketo form that emails the PDF link to the visitor.',
  },
  rtcCardColorField,
  {
    name: 'standalone',
    type: 'boolean',
    defaultValue: false,
    helperText:
      'Wrap the card in a full-width section so it can stand alone on a normal page. Leave off when placing it inside a blog/article body.',
  },
  ...sectionFields,
] as const satisfies DeepReadonly<Input[]>;

const resourceDownloadCardConfig = {
  name: 'resourceDownloadCard',
  inputs: resourceDownloadCardFields,
} as Component;

export type ResourceDownloadCardConfigProps = Omit<GenerateBuilder<typeof resourceDownloadCardFields>, 'form'> &
  FormFieldProps &
  SectionConfigProps;

export default resourceDownloadCardConfig;
